import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    maxWidth: theme.maxContentWidth.largeReduced,
    width: '100%',
    margin: 'auto',
    paddingTop: theme.marginBase * 12,
    paddingBottom: theme.marginBase * 12,
    paddingLeft: theme.marginBase * 3,
    paddingRight: theme.marginBase * 3,
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const SettingContent = ({ children, className }: Props) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.content, className)}>{children}</div>
  );
};
